export default class Util
{
	private g:object = {
		phone : /^1(3\d|5[0-9]|7\d|8[0-9]|47|98|99|66|91|65)\d{8}$/,
		mail : /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
		company : /^[\u4E00-\u9FA5a-zA-Z][\u4E00-\u9FA5a-zA-Z0-9\s-,-.]*$/,
		uname : /^[a-zA-Z][a-zA-Z0-9_]{3,19}$/,
		zh : /^[\u4e00-\u9fa5]+$/,
		card : /^((1[1-5])|(2[1-3])|(3[1-7])|(4[1-6])|(5[0-4])|(6[1-6])|71|(8[12])|91)\d{4}(((((19|20)((\d{2}(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(\d{2}(0[13578]|1[02])31)|(\d{2}02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[48])0229)))|20000229)\d{3}(\d|X|x))|(((\d{2}(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(\d{2}(0[13578]|1[02])31)|(\d{2}02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[48])0229))\d{3}))$/,
		float: /^[0-9|.0-9]*$/,
		pwd : /^(?=.*?[A-Za-z]+)(?=.*?[0-9]+)(?=.*?[A-Z]).*$/
	}

	private $v( type:string, val:string | number ):boolean
	{
		return this.g[type].test( val )
	}

	url( url:string ):void
	{
		window.location.href = url
	}

	/**
	 * 判断并返回合法用户名
	 * @param val 要判断的用户
	 * @returns 
	 */
	username( val:string ):boolean | string
	{
		return this.$v( 'uname', val ) ? val : false
	}

	/**
	 * 判断并返回符合要求的密码
	 * @param val 要判断的密码
	 * @returns 
	 */
	password( val:string ):boolean | string
	{
		return this.$v( 'pwd', val ) ? val : false
	}

	/**
	 * 判断并返回电子邮件
	 * @param val 电子邮件地址
	 * @returns 
	 */
	email( val:string ):boolean | string
	{
		return this.$v( 'mail', val ) ? val : false
	}

	/**
	 * 判断并返回合法的手机号
	 * @param val 手机号
	 * @returns 
	 */
	phone( val:string ):boolean | string
	{
		return this.$v( 'phone', val ) ? val : false
	}

	/**
	 * 判断并返回身份证信息
	 * @param val 身份证号
	 * @returns 
	 */
	idcard( val:string ):boolean | string
	{
		return this.$v( 'card', val ) ? val : false
	}

	/**
	 * 判断并返回浮点数
	 * @param val 浮点数
	 * @returns 
	 */
	float( val:number ):boolean | number
	{
		return this.$v( 'float', val ) ? val : false
	}

	/**
	 * 判断并返回单位名称
	 * @param val 单位名称
	 * @returns 
	 */
	company( val:string ):boolean | string
	{
		return this.$v( 'company', val ) ? val : false
	}

	/**
	 * 格式化日期
	 * @param format 要显示的日期格式,参数参照PHP
	 * @param timestamp 要格式化的时间戳
	 * @returns 格式化后的日期
	 */
	datetime( format:string, timestamp:number ):string
	{
		///	要显示的日期格式
		let f:string = format ? format : 'Y-m-d H:i:s'
	
		let t:Date = typeof timestamp != 'undefined' ? new Date( timestamp.toString().length > 10 ? timestamp : timestamp * 1000 ) : new Date()
		return f.replace( /Y/, t.getFullYear().toString() )
				.replace( /m/, this.cTime( t.getMonth() + 1 ) )
				.replace( /d/, this.cTime( t.getDate() ) )
				.replace( /H/, this.cTime( t.getHours() ) )
				.replace( /i/, this.cTime( t.getMinutes() ) )
				.replace( /s/, this.cTime( t.getSeconds() ) )
	}

	/**
	 * 个性化日期格式化
	 * @param timestamp 要格式化的时间戳
	 * @returns 格式化后的时间戳
	 */
	dateformat( timestamp:number ):string
	{
		let now:number = Math.ceil( new Date().getTime() / 1000 ) ///	当前时间戳
		let diff:number = now - timestamp 						///	参数时间戳与当前时间戳相差秒数
	
		let current:Date = new Date()							///	当前时间日期对象
		let date:Date = new Date( timestamp * 1000 )  			///	参数时间戳转换成的日期对象
	
		let Y:number = date.getFullYear(), 
			m:number = date.getMonth() + 1, 
			d:number = date.getDate()
		let H:number = date.getHours(), 
			i:number = date.getMinutes(), 
			s:number = date.getSeconds()
	
		///	一分钟以内
		if( diff < 60 )
		{
			return `刚刚`
		}
		///	一小时前之内
		else if( diff < 3600 )
		{
			return `${ Math.floor( diff / 60 ) }分钟前`
		}
		///	今天
		else if( current.getFullYear() == Y && current.getMonth() + 1 == m && current.getDate() == d )
		{
			return `${this.cTime( H )}:${this.cTime( i )}:${this.cTime( s )}`
		}
		else
		{
			///	参数中的时间戳加一天转换成的日期对象
			let newDate = new Date( ( now - 86400 ) * 1000 )
			if( newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d )
			{
				return `昨天${this.cTime( H )}:${this.cTime( i )}`
			}
			else if( current.getFullYear() == Y )
			{
				return  `${this.cTime( m )}月${this.cTime( d )}日`
			}
			else
			{
				return  `${Y}年`
			}
		}
	}

	/**
	 * 时间日期补0
	 * @param i 要补0的数据
	 * @returns 
	 */
	private cTime( i:number ):string
	{
		return i < 10 ? `0${i}` : i.toString()
	}

	/**
	 * 图片转base64
	 * @param img 
	 * @param callback 
	 */
	img2base64( img:Blob, callback:Function )
	{
		let reader:FileReader = new FileReader()
			reader.addEventListener( 'load', () => callback( reader.result ) )
			reader.readAsDataURL( img )
	}

	/**
	 * 清除字符串左右的空白
	 * @param str 
	 * @returns 
	 */
	tm( str:string ):string
	{
		return str.replace( /^\s+|\s+$/gm, '' )
	}

	/**
	 * 简单选择器
	 * @param node html class 或 id
	 * @returns dom对象
	 */
	$( node:string ):HTMLElement
	{
		let command:string = 'querySelectorAll'
	
		if( node.indexOf( '#' ) === 0 )
			command = 'getElementById'
	
		if( node.indexOf( '.' ) === 0 )
			command = 'getElementsByClassName'
			
		return document[command]( this.substr( node, 1, node.length ) )
	}

	/**
	 * 字符串截取
	 * @param str 要截取的字符串
	 * @param s 起始位置
	 * @param l 长度
	 * @returns 
	 */
	substr( str:string, s:number, l:number ):string
	{
		return str.slice( s ? s : 0, l ? l : 1 )
	}

	/**
	 * JSON转formdata
	 * @param json 要转换的JSON数据
	 * @returns 
	 */
	json2formdata( json:JSON ):FormData
	{
		let $fd:FormData = new FormData()
		for( let x in json )
		{
			$fd.append( x, json[x] )
		}
		return $fd
	}

	/**
	 * 判断某个值是否在数组中
	 * @param val 要判断的值
	 * @param arr 数组
	 * @returns 
	 */
	in_array( val:any, arr:any[] ):boolean
	{
		for( let i:number = 0, j:number = arr.length; i < j; i++ )
		{
			if( arr[i] == val )
				return true
		}
		return false;
	}

	/**
	 * 判断对象的key是否存在
	 * @param key 要判断的Key
	 * @param obj 对象
	 * @returns 
	 */
	object_key_exists( key:string, obj:object ):boolean
	{
		for( let x in obj )
		{
			if( key == x )
				return true
		}
		return false
	}

	/**
	 * 判断对象的值是否存在
	 * @param val 要判断的值
	 * @param obj 对象
	 * @returns 
	 */
	object_value_exists( val:any, obj:object ):boolean
	{
		for( let x in obj )
		{
			if( obj[x] == val )
				return true
		}
		return false
	}
}


// WEBPACK FOOTER //
// ./src/lib/util.ts